<template>
    <div>
        <TabWrapper @deploy:preview="$emit('deploy:preview')"
                    @deploy:live="$emit('deploy:live')">
            <v-container fluid>
                <v-row justify="center" no-gutters>
                    <v-col cols="12" lg="10">
                        <Datatable
                            :items="items"
                            :headers="tableHeaders" title="Artikel URLs & Keywords"
                            @click:row="selected=$event; showEditDialog = true"
                            @click:delete="selected=$event; showDeleteDialog = true"
                        >
                            <template #top>
                                <div v-if="!readOnly" style="display:flex; align-items: center">
                                    <Button v-if="$vuetify.breakpoint.smAndUp" class="ml-8"
                                            icon="mdi-plus" :color="ada.blue" @click="showEditDialog = true">URL
                                        hinzufügen
                                    </Button>
                                    <TooltipIcon v-else :color="ada.blue" :fab="true"
                                                 @click="showEditDialog = true"
                                                 tooltip="URL / Keywordmach  hinzufügen">mdi-plus
                                    </TooltipIcon>
                                </div>
                            </template>
                        </Datatable>

                        <div class="mt-10">
                            <p>Dies ist eine Liste von Artikel (Teil) URLs und Keywords, auf denen <b>keine AdTags</b>
                                gerendert
                                werden
                                dürfen. <b>ACHTUNG: Einträge werden direkt mit dem nächsten Live Deployment
                                    ausgeliefert.</b></p>
                            <p>Sie gilt für die komplette Seite und ist <b>nicht</b> Sitetype spezifisch.</p>
                            <p>
                                Es gibt Bereiche, die von Google aufgrund von Policy Verstößen angemahnt werden.
                                Wenn dort die Ausspielung der AdTags nicht unterbunden wird,
                                ist die gesamte Werbeausspielung auf dem jeweiligen Publisher gefährdet.
                            </p>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </TabWrapper>

        <!-- EDIT / ADD DIALOG -->
        <Dialog v-model="showEditDialog"
                title="Neue Artikel URL / Keyword hinzufügen"
                :ok-disabled="!validate"
                :loading="loading"
                @ok="save"
                @click:outside="close"
                @cancel="close">
            <Input v-model="url" label="Artikel URL / Keyword"
                   :error-messages="urlErrors"
                   :required="true"
                   @enter="save"
                   @input="$v.url.$touch()"
                   @blur="$v.url.$touch()"></Input>
        </Dialog>

        <!-- DELETE DIALOG -->
        <Dialog v-model="showDeleteDialog"
                title="Artikel URL / Keyword löschen ?"
                :loading="loading"
                @click:outside="close"
                @ok="deleteURL" ok-text="Löschen"
                @cancel="close">
            Soll die Artikel URL <b>{{ selected ? selected.Url : null }}</b>
            wirklich gelöscht werden?
        </Dialog>
    </div>
</template>

<script>
import TabWrapper from "./TabWrapper";
import Datatable from "../../../components/Tables/Datatable";
import TooltipIcon from "../../../components/TooltipIcon";
import ada from "../../../scss/ada_colors.scss";
import Button from "../../../components/buttons/Button";
import Dialog from "../../../components/Dialog";
import Input from "../../../components/Inputs/Input";
import Utils from "../../../scripts/Utils";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

export default {
    name: "AdTagRendering",
    components: {Input, Dialog, Button, TooltipIcon, Datatable, TabWrapper},
    props: ['readOnly'],
    mixins: [validationMixin],
    validations: {
        url: {required},
    },
    data: () => ({
        showEditDialog: false,
        showDeleteDialog: false,
        loading: false,
        selected: null,
        url: null,
        headers: [
            {text: 'Artikel URL / Keyword', value: 'Url', width: '90%'},
            {text: 'Erstellt am', width: '150px', value: 'created_at'},
        ],
        ada
    }),
    computed: {
        tableHeaders() {
            let ret = JSON.parse(JSON.stringify(this.headers));
            if (!this.readOnly) ret.push({text: 'Aktion', value: 'action', width: '100px', sortable: false});
            return ret;
        },
        siteDetails() {
            return this.$store.state.display.siteDetails;
        },
        items() {
            let ret = this.siteDetails ? this.siteDetails.URLs : [];
            ret.forEach((item) => {
                item.created_at = Utils.formatDate(item.Created);
                item.action = [];
                if (!this.readOnly) item.action.push('delete');
            });
            return ret;
        },
        activeTab() {
            return this.$store.state.display.activeTab;
        },
        urlErrors() {
            return Utils.handleError(this, 'url', 'URL ist erforderlich.');
        },
        validate() {
            return this.urlErrors.length === 0;
        }
    },
    methods: {
        init() {
            if (this.selected) {
                this.url = this.selected.Url;
            } else {
                this.url = '';
            }
        },
        async save() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                try {
                    let data = await this.$store.dispatch('display/editURL', this.getBody());
                    this.loading = false;
                    if (data.Status) {
                        this.$root.$emit('snackbar', 'Artikel URL / Keyword erfolgreich angelegt');
                        this.close();
                    }
                } catch (e) {
                    this.loading = false;
                }
            }
        },
        async deleteURL() {
            this.loading = true;
            try {
                let data = await this.$store.dispatch('display/deleteURL', this.getBody(true));
                this.loading = false;
                if (data.Status) {
                    this.$root.$emit('snackbar', 'Artikel URL / Keyword erfolgreich gelöscht');
                    this.close();
                }
            } catch (e) {
                this.loading = false;
            }
        },
        getBody(isDelete = false) {
            let json = {
                url_id: this.selected ? this.selected.SiteBlockedurlsId : null,
                site_id: this.selected ? this.selected.SiteId : this.$store.state.display.selectedSite.SiteId,
                type_id: this.$store.state.display.selectedType.SitetypeId,
            };
            if (!isDelete) json.url = this.url;
            return json;
        },
        close() {
            if (this.showEditDialog) this.showEditDialog = false;
            if (this.showDeleteDialog) this.showDeleteDialog = false;
            this.selected = null;
        }
    },
    watch: {
        activeTab() {
            if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        },
        showEditDialog() {
            if (this.showEditDialog) {
                this.init();
            }
        }
    }
}
</script>

<style scoped>

</style>